import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import Results from './Results';
import WordOfTheDay from './WordOfTheDay';
import Photos from './Photos';
import Header from './Header';
import SearchBar from './SearchBar';


import sampleMusic from '../assets/music.mp3';
import lightModeImage from '../assets/light-mode-dictionary.png';
import darkModeImage from '../assets/dark-mode-dictionary.png';
import '../styles/Dictionary.css';

export default function Dictionary() {
    const [keyword, setKeyword] = useState('');
    const [results, setResults] = useState(null);
    const [score, setScore] = useState(0);
    const [isPlaying, setIsPlaying] = useState(false);
    const [darkMode, setDarkMode] = useState(false);
    const [showWordOfTheDay, setShowWordOfTheDay] = useState(true);
    const audioRef = useRef(new Audio(sampleMusic));
    const [photos, setPhotos] = useState(null);

    const urlParams = new URLSearchParams(window.location.search);
    const lang = urlParams.get('lang') || 'en';

    function handleResponse(response) {
        setResults(response.data[0]);
        setScore(score + 1);
        setShowWordOfTheDay(false);
    }

    function handleImageResponse(response) {
        setPhotos(response.data.photos);
    }

    function search(event) {
        event.preventDefault();
        let apiUrl = `https://api.dictionaryapi.dev/api/v2/entries/${lang}/${keyword}`;
        axios.get(apiUrl).then(handleResponse);

        let imageApiKey = '3734of2cfc5035aca32f96t5a9b478fb';
        let imageApiUrl = `https://api.shecodes.io/images/v1/search?query=${keyword}&key=${imageApiKey}`;
        axios.get(imageApiUrl).then(handleImageResponse);
    }

    function togglePlay() {
        if (isPlaying) {
            audioRef.current.pause();
        } else {
            audioRef.current.play();
        }
        setIsPlaying(!isPlaying);
    }

    function toggleTheme() {
        setDarkMode(!darkMode);
    }

    function goBack() {
        setResults(null);
        setShowWordOfTheDay(true);
        setPhotos(null); // Reset photos when going back
    }

    useEffect(() => {
        if (darkMode) {
            document.body.classList.add('dark-mode');
            document.body.style.backgroundImage = `url(${darkModeImage})`;
        } else {
            document.body.classList.remove('dark-mode');
            document.body.style.backgroundImage = `url(${lightModeImage})`;
        }
    }, [darkMode]);

    return (
        <div className="Dictionary">
            <Header 
                isPlaying={isPlaying}
                togglePlay={togglePlay}
                darkMode={darkMode}
                toggleTheme={toggleTheme}
                score={score}
            />
            <SearchBar 
                keyword={keyword}
                setKeyword={setKeyword}
                search={search}
            />
            {showWordOfTheDay && (
                <WordOfTheDay lang={lang} setScore={setScore} />
            )}
            {results && (
                <div>
                    <button className="back-button" onClick={goBack}>Back</button>
                    <Results results={results} />
                </div>
            )}
            <Photos photos={photos} keyword={keyword} />
            
        </div>
    );
}
